export function buildErrorCatalogContext(moduleName: string) {
  return { moduleName };
}
